export const recommendationCarouselPlaceholderVariable = '{basedOnTitle}';
